import isEmpty from 'lodash/isEmpty';

import { TFunction } from '@lyearn/i18n';
import { Fields, FieldType } from '@/components/Form';
import { PropertiesToDuplicateEnum } from '@/types/schema';

import {
  getListPropertiesToDuplicateOptions,
  getTaskPropertiesToDuplicateOptions,
  ListPropertiesToDuplicateEnum,
} from '../../utils';
import PropertiesToDuplicateSelector from '../PropertiesToDuplicateSelector';

export type ListDuplicationFormPropertiesType = {
  listPropertiesToDuplicate: ListPropertiesToDuplicateEnum[];
  actionItemPropertiesToDuplicate: PropertiesToDuplicateEnum[];
};

export type DuplicateListEditorFormValues = {
  title: string;
  duplicateFromId: string;
  properties: ListDuplicationFormPropertiesType;
};

export const getInitialValues = ({
  t,
  duplicateFromId,
  title,
}: {
  t: TFunction;
  duplicateFromId?: string;
  title?: string;
}): DuplicateListEditorFormValues => {
  return {
    duplicateFromId: duplicateFromId || '',
    title: title ? title + t('Task:DuplicationProperties.Copy') : t('Task:DuplicateList.Title'),
    properties: {
      listPropertiesToDuplicate: getListPropertiesToDuplicateOptions(t).map(
        (option) => option.value,
      ),
      actionItemPropertiesToDuplicate: getTaskPropertiesToDuplicateOptions(t).map(
        (option) => option.value,
      ),
    },
  };
};

export const getFormFields = (t: TFunction): Fields<DuplicateListEditorFormValues> => {
  return {
    title: {
      name: 'title',
      label: t('Task:DuplicateList.NewListName'),
      type: FieldType.Text,
      size: 'large',
      required: true,
    },
    properties: {
      name: 'properties',
      required: true,
      type: FieldType.Custom,
      label: t('Task:DuplicationProperties.PropertiesToDuplicateLabel'),
      Component: ({ value, onChange }) => {
        return <PropertiesToDuplicateSelector value={value} onChange={onChange} />;
      },
    },
  };
};

export const FORM_LAYOUT = ['title', 'properties'];

export const validateForm = (t: TFunction) => (values: any) => {
  const errors: any = {};

  if (isEmpty(values.title)) {
    errors.title = t('Task:DuplicateList.ListNameCannotBeEmpty');
  }

  return errors;
};
